<template>
  <div>
    <div class="air__utils__scrollTable mb-4">
      <a-table
        :rowKey="record => record.id"
        :columns="columns"
        :dataSource="data"
        :pagination="false"
        :scroll="{ x: '100%' }"
        :rowSelection="computedSelect"
        :loading="loading"
      >
        <template slot="name" slot-scope="name">
          <div>
            <div class="font-weight-bold">{{name.first_name}} {{name.last_name}}</div>
          </div>
        </template>
        <template slot="gender" slot-scope="gender">
          <span class="font-weight-bold">{{gender}}</span>
        </template>
        <template slot="category" slot-scope="category">
          <span class="font-weight-bold">{{category}}</span>
        </template>
        <template slot="phone" slot-scope="phone">
          <span class="font-weight-bold">{{phone.country_code}}{{phone.phone}}</span>
        </template>
        <template slot="role" slot-scope="role">
          <span class="font-weight-bold">{{role.charAt(0).toUpperCase() + role.slice(1)}}</span>
        </template>
        <template slot="status" slot-scope="status">
          <a-tag :color="status ? 'green' : 'red'">{{status ? 'Active' : 'Inactive'}}</a-tag>
        </template>
        <template slot="action" slot-scope="text, record">
          <div class="text-nowrap">
            <a href="javascript:;" class="btn btn-sm btn-with-addon mr-2"
            :class="record.status ? 'btn-warning' : 'btn-success'"
              @click="toggleStatus(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fa" :class="record.status ? 'fa-lock' : 'fa-unlock'"/>
              </span>
              {{record.status ? 'Deactivate' : 'Activate'}}
            </a>
            <!-- Edit -->
            <a href="javascript:;" class="btn btn-sm btn-light btn-with-addon mr-2"
              @click="showEditModal(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-edit" />
              </span>
              <!-- <edit-user ref="editUser" @edited="handleEdited"/> -->
              Edit
            </a>
            <!-- Delete -->
            <a href="javascript:;" class="btn btn-sm btn-danger btn-with-addon"
              @click="onDelete(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-trash" />
              </span>
              Delete
            </a>
          </div>
        </template>
      </a-table>
    </div>

    <edit-user ref="editUser" @edited="handleEdited"/>
  </div>
</template>
<script>
import moment from 'moment'
import EditUser from '@/components/user/Forms/Edit/index'

const columns = [
  {
    title: `User's Name`,
    className: 'text-left text-gray-6',
    key: 'first_name',
    scopedSlots: { customRender: 'name' },
    sorter: (a, b) => a.first_name.localeCompare(b.first_name),
  },
  {
    title: 'Email',
    dataIndex: 'email',
    scopedSlots: { customRender: 'email' },
    sorter: (a, b) => a.email.localeCompare(b.email),
  },
  {
    title: 'Phone No',
    key: 'phone',
    scopedSlots: { customRender: 'phone' },
    sorter: (a, b) => a.phone - b.phone,
  },
  {
    title: 'Role',
    dataIndex: 'role',
    key: 'role',
    scopedSlots: { customRender: 'role' },
    sorter: (a, b) => a.role.localeCompare(b.role),
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    scopedSlots: { customRender: 'status' },
    sorter: (a, b) => a.status - b.status,
  },
  {
    title: 'Actions',
    dataIndex: 'action',
    className: 'text-right',
    scopedSlots: { customRender: 'action' },
  },
]

export default {

  name: 'UersTable',
  components: {
    EditUser,
  },
  props: {
    select: Boolean,
    loading: Boolean,
    data: {
      type: Array,
      default: () => [],
    },
  },
  data: function() {
    return {
      columns,
      selectedRowKeys: [],
      tableLoading: this.loading,
    }
  },
  computed: {
    computedSelect: function() {
      if (!this.select) {
        return null
      }
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      }
    },
  },
  methods: {
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    showEditModal: function(record) {
      // this.$refs.editUser.showModal(record.id)
      this.$eventBus.$emit('openUserEditModal', record.id)
    },
    handleEdited: function () {
      this.$emit('updateTable')
    },
    handleDate: function($date) {
      return moment($date).format('DD-MM-YYYY')
    },
    toggleStatus: function(record) {
      this.$confirm({
        title: 'Are you sure?',
        content: 'Clicking Yes will toggle the user status',
        okText: 'Yes',
        okType: 'primary',
        cancelText: 'No',
        onOk: () => {
          // this.$nprogress.start()
          this.tableLoading = true
          this.$http
            .get('/api/user/status/' + record.id)
            .then(({ data }) => {
              this.$emit('updateTable')
              // this.$nprogress.done()
              this.tableLoading = false
              this.$notification['success']({
                message: 'Status changed successfully!',
                description: data.message,
              })
            })
            .catch(error => {
              // this.$nprogress.done()
              this.loading = false
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
    onDelete: function(record) {
      this.$confirm({
        title: 'Are you sure delete this user?',
        content: 'Clicking Yes will delete the user!',
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/user/' + record.id)
            .then(() => {
              this.$emit('updateTable')
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Deleted Successfully!',
                description: record.first_name + ' ' + record.last_name + ' has been deleted.',
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$notification['error']({
                message: 'Unable to delete!',
                description: error.response.data.message,
              })
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
  },
}
</script>
